module.exports = __webpack_public_path__ + "static/media/clc_newsletter_01_20201224.8f044d74.pdf";